import React from "react";
import ReactDOM from "react-dom";
import { AuthProvider } from "react-oidc-context";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import oidc from "./OidcConfig";

import "./index.css";
import "./Fonts.css";

ReactDOM.render(
  <HelmetProvider>
    <AuthProvider {...oidc}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </AuthProvider>
  </HelmetProvider>,
  document.getElementById("root")
);

reportWebVitals();
